import { render, staticRenderFns } from "./TemplateFach.vue?vue&type=template&id=163795c6&"
import script from "./TemplateFach.vue?vue&type=script&lang=js&"
export * from "./TemplateFach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports